export default [
  {
    path: "/banquet-inquiry",
    component: () => import("../layout/PageLayoutWithoutContainer.vue"),
    beforeEnter: (to, from, next) => {
      if (process.env.VUE_APP_ENABLE_BANQUET_INQUIRY === "true") {
        next();
      } else {
        next({ path: "/page-not-found" });
      }
    },
    children: [
      {
        path: "",
        name: "Banquet Inquiry",
        component: () => import("@/views/BanquetInquiry/BanquetInquiry.vue")
      }
    ]
  }
];
